// @flow

import { combineReducers } from 'redux-immutable';

import upload from './upload';
import download from './download';

export default combineReducers({ upload, download });